import {Switch} from 'antd';
import React from 'react';

import {LockIcon} from '../..';
import {STRINGS} from '../../..';

import './switchRow.scss';

interface SwitchRowProps {
  label: string | React.ReactNode;
  onChange: (checked: boolean) => void;
  checked: boolean;
  isLock: boolean;
  onLockClick?: () => void;
}

export const SwitchRow = ({label, onChange, checked, isLock, onLockClick}: SwitchRowProps) => {
  return (
    <div className="switchRow">
      <div className="switchRowLeft">
        <span className="switchRowLabel">{label}</span>
        {isLock && onLockClick && (
          <LockIcon onClick={() => (onLockClick ? onLockClick() : null)} message={STRINGS.message_unlock_feature} />
        )}
      </div>
      <Switch onChange={onChange} checked={checked} disabled={isLock} />
    </div>
  );
};
